<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- 1. لوحة التحكم -->
    <div class="card shadow-sm mb-4 border-top-danger no-print">
      <div class="card-header bg-white py-3">
        <h5 class="mb-0 text-danger fw-bold">
          <i class="fas fa-file-medical-alt ms-2"></i> كشوف الامتحان التكميلي (غياب الترم الأول)
        </h5>
      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-4">
            <label class="form-label fw-bold">القطاع</label>
            <select v-model="filters.sector" class="form-select">
              <option value="">-- الكل --</option>
              <option value="1">قطاع العريش</option>
              <option value="2">قطاع بئر العبد</option>
            </select>
          </div>
          <div class="col-md-4">
            <button @click="fetchData" class="btn btn-danger w-100 fw-bold" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm ms-2"></span>
              تجهيز الكشوف
            </button>
          </div>
          <div class="col-md-4">
             <button @click="printPage" class="btn btn-dark w-100" :disabled="reportData.length === 0">
               <i class="fas fa-print ms-2"></i> طباعة
             </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. التقرير -->
    <div id="printMe" v-if="reportData.length > 0">
      
      <!-- حلقة تكرار لكل مدرسة -->
      <div 
        v-for="(school, index) in reportData" 
        :key="index" 
        class="school-section"
      >
        
        <!-- ترويسة -->
        <header class="mb-4 border-bottom pb-2">
          <div class="row text-center align-items-center">
            <div class="col-4 text-start">
              <h6 class="fw-bold mb-1">محافظة شمال سيناء</h6>
              <h6 class="fw-bold mb-0">لجنة النظام والمراقبة</h6>
            </div>
            <div class="col-4">
              <h3 class="fw-bold text-decoration-underline">كشف الامتحان التكميلي</h3>
              <h6 class="text-danger fw-bold">(الطلاب المتغيبين في الترم الأول)</h6>
            </div>
            <div class="col-4 text-end">
              <h6 class="fw-bold mb-1">العام الدراسي: 2026</h6>
              <h6 class="fw-bold mb-0 text-muted">شئون الطلبة</h6>
            </div>
          </div>
          
          <div class="mt-3 bg-light p-2 border border-dark text-center rounded">
             <h4 class="m-0 fw-bold">مدرسة: {{ school.school_name }}</h4>
          </div>
        </header>

        <!-- أ. جدول إحصاء المواد (هام للمطبعة) -->
        <div class="mb-4">
            <h6 class="fw-bold text-decoration-underline mb-2">أولاً: إحصاء أوراق الأسئلة المطلوبة:</h6>
            <div class="table-responsive">
                <table class="table table-bordered border-dark text-center table-sm mb-0 w-auto mx-auto">
                    <thead class="bg-secondary text-white">
                        <tr>
                            <th v-for="(count, subject) in school.stats" :key="subject" class="px-3">{{ subject }}</th>
                            <th class="bg-dark">إجمالي الطلاب</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="fw-bold fs-5">
                            <td v-for="(count, subject) in school.stats" :key="'val-'+subject">{{ count }}</td>
                            <td class="bg-light">{{ school.students.length }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- ب. جدول الأسماء -->
        <h6 class="fw-bold text-decoration-underline mb-2">ثانياً: كشف أسماء الطلاب والمواد:</h6>
        <table class="table table-bordered border-dark text-center align-middle">
          <thead class="table-light">
            <tr>
              <th width="5%">م</th>
              <th width="15%">رقم الجلوس</th>
              <th width="35%">اسم الطالب</th>
              <th width="45%">مواد التخلف (الامتحان التكميلي)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(student, sIndex) in school.students" :key="sIndex">
              <td>{{ sIndex + 1 }}</td>
              <td class="fw-bold font-monospace fs-5">{{ student.seat_number }}</td>
              <td class="text-start pe-3 fw-bold">{{ student.name }}</td>
              <td class="text-danger fw-bold bg-light">{{ student.subjects }}</td>
            </tr>
          </tbody>
        </table>

        <!-- تذييل -->
        <div class="mt-4 d-flex justify-content-around fw-bold break-avoid">
            <div>المراجع</div>
            <div>رئيس الكنترول</div>
        </div>

        <div class="page-break"></div>

      </div>
    </div>
    
    <div v-else-if="searched" class="alert alert-info text-center mt-5 no-print">
        لا توجد مدارس بها طلاب تكميلي في هذا القطاع.
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "SupplementaryExamReport",
  data() {
    return {
      loading: false,
      searched: false,
      filters: { sector: '' },
      reportData: []
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.searched = true;
      try {
        const res = await api.get('/admin/supplementary-report', { params: this.filters });
        this.reportData = res.data;
      } catch (e) {
        alert("خطأ");
      } finally {
        this.loading = false;
      }
    },
    printPage() {
        this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
.border-top-danger { border-top: 4px solid #dc3545; }

@media print {
  @page { size: A4 portrait; margin: 10mm; }
  body * { visibility: hidden; }
  .no-print { display: none !important; }
  #printMe, #printMe * { visibility: visible; }
  #printMe { position: absolute; left: 0; top: 0; width: 100%; }
  
  .school-section { page-break-after: always; }
  .break-avoid { page-break-inside: avoid; }
  
  .table-bordered th, .table-bordered td {
      border: 1px solid #000 !important;
      padding: 5px !important;
  }
  
  .bg-secondary { background-color: #6c757d !important; color: white !important; -webkit-print-color-adjust: exact; }
  .bg-light { background-color: #f8f9fa !important; -webkit-print-color-adjust: exact; }
}
</style>